import { times } from 'lodash';
import { css } from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { Dotdotdot } from '@hivebrite/design-system/Dotdotdot';

import Grid, { Col, Row } from 'hb-react/shared/components/DesignSystem/Grid';

import { TopicLoadingCard } from './TopicLoadingCard';
import useTopicsUserAuthorization from '../hooks/useTopicsUserAuthorization';

const TopicsUserAuthorization = () => {
  const { itemsPerRow, menuName } = useTopicsUserAuthorization();

  return (
    <Grid data-testid="topics-user-authorization">
      <Row>
        <Col width={12 / 12}>
          <Box font="h2-semibold">
            <Dotdotdot clamp={2}>
              {`${s__('Topics|%{menuName}').i__({
                menuName,
              })}`}
            </Dotdotdot>
          </Box>
        </Col>
      </Row>
      <Row>
        {times(itemsPerRow * 2, (i) => (
          <Col
            key={i}
            width={{ m: 1 / 2, l: 1 / 3, xl: 1 / 4 }}
            pt={0}
            css={css`
              width: 100%;
            `}
          >
            <TopicLoadingCard isStatic />
          </Col>
        ))}
      </Row>
    </Grid>
  );
};

export default TopicsUserAuthorization;
